var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(!_vm.$route.meta.isStandalone)?_c('com-head'):_vm._e(),(!_vm.$route.meta.isStandalone && !_vm.$route.meta.isCommunity)?_c('com-panel'):_vm._e(),_c('com-content',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }